export class ApiClient {
    static async get<T>(url: string): Promise<T> {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        });
        return this.handleResponse<T>(response);
    }

    static async post<T>(url: string, data: any): Promise<T> {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return this.handleResponse<T>(response);
    }

    static async put<T>(url: string, data: any): Promise<T> {
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return this.handleResponse<T>(response);
    }

    static async delete(url: string): Promise<void> {
        const response = await fetch(url, {
            method: 'DELETE'
        });
        if (!response.ok) {
            await this.handleError(response);
        }
    }

    private static async handleResponse<T>(response: Response): Promise<T> {
        if (!response.ok) {
            await this.handleError(response);
        }
        // Handle 204 No Content
        if (response.status === 204) {
            return {} as T;
        }
        return await response.json();
    }

    private static async handleError(response: Response): Promise<never> {
        let errorMessage = response.statusText;
        try {
            const errorBody = await response.text();
            errorMessage = errorBody || errorMessage;
        } catch (e) {
            // ignore
        }
        throw new Error(errorMessage);
    }
}
